import { Carousel } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import Footer from "../pages/Footer";
import Header from "../pages/Header";
import "./Productvideo.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import { Colors, Web_url } from "../../common/Const";
import { images } from "../../common/Images";

const Productvideo = () => {
  
  // const videos = [
  //   { id: 1, video_url: "https://www.youtube.com/embed/jcLHBk98360" },
  //   { id: 2, video_url: "https://www.youtube.com/embed/jcLHBk98360" },
  //   { id: 3, video_url: "https://www.youtube.com/embed/jcLHBk98360" },
  //   { id: 4, video_url: "https://www.youtube.com/embed/jcLHBk98360" },
  //   { id: 5, video_url: "https://www.youtube.com/embed/jcLHBk98360" },
  //   { id: 6, video_url: "https://www.youtube.com/embed/jcLHBk98360" },
  // ];
  
  let{state} = useLocation()
  let { p_video } =state;
  const[promoVideo,setPromovideo]= useState(p_video.product_Videos);
const [palyed, setPlayed] = useState([]);
  // console.log(promoVideo)


  useEffect(()=>{
    setPlayed(p_video.product_Videos[0]);
  },[])

  // console.log(p_video);
    const [windowSize, setWindowSize] = useState(window.innerWidth);
     const [open, setOpen] = useState(false);
     const handleOpen = (url) => {
      // console.log(url)
      setOpen(true)
    setPlayed(url)};
     const handleClose = () => setOpen(false); 


     const style = {
       position: "absolute",
       top: "50%",
       left: "50%",
       transform: "translate(-50%, -50%)",
       width:  windowSize != null && windowSize >= 1440
                  ? 1000
                  : windowSize >= 1366
                  ? 1000
                  : windowSize >= 1280
                  ? 1000
                  : windowSize >= 1024
                  ? 800
                  : windowSize >= 768
                  ? 800
                  : windowSize >= 412
                  ? 400
                  : windowSize >= 360
                  ? 350
                  : 300,
       bgcolor: "background.paper",
       boxShadow: 24,
       p: 4,
     };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <Header make={true} />
      <div className="row justify-content-center product_video">
        <div className="col-xxl-10 col-xl-10 col-lg-10 col-10">
          <div className="d-flex flex-column gap-2 ">
            <div className="d-flex justify-content-between">
              <span className="title">Video</span>
              <div className="">
                <a
                  href="javascript:history.go(-1)"
                  style={{ textDecoration: "none" }}
                >
                  <button
                    className="btn btn-sm"
                    style={{
                      backgroundColor: Colors.Base_color,
                      color: "white",
                    }}
                  >
                    <div className="d-flex align-items-center gap-2 mx-2">
                      <i
                        class="fa-solid fa-caret-left"
                        style={{ fontSize: "18px" }}
                      ></i>
                      <span style={{ paddingTop: "1px" }}>Back</span>
                    </div>
                  </button>
                </a>
              </div>
            </div>

            {/* <span className="video_des text-muted">
              {" "}
              Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              quis elit bibendum, posuere velit nec, placerat magna.
            </span> */}
          </div>
          <div className="videocarousel">
            <Swiper
              slidesPerView={
                windowSize != null && windowSize >= 1440
                  ? 3
                  : windowSize >= 1366
                  ? 2
                  : windowSize >= 1280
                  ? 2
                  : windowSize >= 1024
                  ? 2
                  : windowSize >= 768
                  ? 2
                  : windowSize >= 412
                  ? 1
                  : windowSize >= 360
                  ? 1
                  : 1
              }
              spaceBetween={10}
              modules={[Pagination]}
              navigation={{
                nextEl: ".review-swiper-button-next-1",
                prevEl: ".review-swiper-button-prev-1",
              }}
              className="mySwiper"
              pagination={{ clickable: true }}
            >
              {promoVideo && promoVideo != "" ? (
                promoVideo.map((data) => {
                  return (
                    <SwiperSlide>
                      <Fragment key={data.id}>
                        <div class="ratio ratio-21x9">
                          <video
                            style={{ borderRadius: "30px", width: "100%" }}
                            // controls
                          >
                            <source src={Web_url.Domain_url + data} />
                          </video>
                          <i
                            class="fa-solid fa-circle-play play"
                            onClick={() =>
                              handleOpen(Web_url.Domain_url + data)
                            }
                            style={{ cursor: "pointer" }}
                          ></i>
                        </div>
                      </Fragment>
                    </SwiperSlide>
                  );
                })
              ) : (
                <span style={{ display: "flex", justifyContent: "center" }}>
                  No Video for this product
                </span>
              )}
            </Swiper>
          </div>

          {/* <Carousel autoplay>
            {videos.map((data) => {
              return (
                <Fragment key={data.id}>
                  <div class="ratio ratio-21x9">
                    <iframe
                      style={{ borderRadius: "30px" }}
                      src={data.video_url}
                      title="YouTube video"
                      allowfullscreen
                    ></iframe>
                  </div>
                </Fragment>
              );
            })}
          </Carousel> */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div>{/* <i class="fa-solid fa-xmark-large"></i> */}</div>
              <video
                style={{ borderRadius: "30px", width: "100%" }}
                controls
                autoPlay
                loop
                onClick={handleOpen}
              >
                <source src={palyed} />
              </video>
            </Box>
          </Modal>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Productvideo;
